<template>
    <div class="full-screen">
        <div class="full-screen" v-if="!secondImgSet">
            <img v-for="index in 40" :src="getRandomImg()" :key="`fud-#${index}`" :class="`fud-${index}`"/>
        </div>
        <div class="full-screen" v-if="secondImgSet">
            <img v-for="index in 40" :src="getRandomImg()" :key="`fud-#${index+40}`" :class="`fud-${index+40}`"/>
        </div>
        <div class="floating">
            <p class="labz-text">Its ok LabZ, We forgive you.</p>
            <div class="slider-row">
                <p class="slider-row-text">XSN price:</p>
                <input type="range" class="sul-range slider-row-slider block" min="1" max="100" v-model="xsnPriceLog">
                <p class="slider-row-value block" v-text="`$${xsnPriceString}`"/>
            </div>
            <div class="slider-row">
                <p class="slider-row-text">VOLUME:</p>
                <input type="range" class="sul-range slider-row-slider trading" min="1" max="100" v-model="xsnPriceLog">
                <p class="slider-row-value trading" v-text="`$${tradingVolumeString}`"/>
            </div>
            <div class="slider-row">
                <h2 class="title-section calculated-text">TOTAL REWARDS:</h2>
                <p class="slider-row-value block big-value">
                    ${{totalRewardsString}}
                    <br/>
                    <span class="value-small-font">/year</span>
                </p>
            </div>
            <div class="slider-row">
                <h2 class="title-section calculated-text">LABZ WAGE (10k / year) EQUIVALENCE: </h2>
                <p class="slider-row-value block med-value">
                    {{wagieEquivalence}}
                </p>
            </div>
            <div class="mcd-worker-row">
                <img
                    v-for="index in wagieEquivalenceCeil"
                    :key="index"
                    :class="['mcd-worker', wagieEquivalenceCeil > 12 && 'mcd-worker-small', 'always-shake']"
                    :style="index > wagieEquivalence ? {width: ((1 - (index - wagieEquivalence)) * (wagieEquivalenceCeil > 12 ? 30 : 100) * (166/202) + 'px')} : undefined"
                    src="../assets/md-worker.jpeg"
                    alt="mcWorker"/>
            </div>
        </div>
    </div>
</template>

<script>
    const imgs = [
        'wojak-tight.png',
        'amm-smart-contract.png',
        'another-day-at-the-lab.png',
        'architect-discord.png',
        'cant-make-this-shit-up.png',
        'diaper-pedo.png',
        'fork-of-dash-1.png',
        'labs-desperation-cope.png',
        'labs-out.png',
        'labs-yankee-scamming.png',
        'labz-dash-fork.png',
        'labz-tight.png',
        'labz.png',
        'no-smart-contract.png',
        'piece-of-shit-dash.png',
        'pos-equals-xsn.jpg',
        'turkish-pothole.png',
        'x9-devs.png',
        'x9-mumbai.png',
        'labz-mad-at-architect.png',
    ]
    export default {
        data() {
            return {
                secondImgSet: false,
                currentXsnPrice: 1,
                xsnPriceLog: 23,
                ownedNodesLog: 2,
                masternodeCount: 2700,
                dayMonthYear: 'year',
                orderbookHostingEnabled: true,
                orderbookMNs: 1500,
            }
        },
        mounted() {
            setInterval(() => {
                this.secondImgSet = !this.secondImgSet
            }, 4000)
        },
        methods: {
            getRandomImg: function() {
                const index = Math.round(Math.random() * (imgs.length - 1))
                const imgSrc = imgs[index];
                return require('../assets/fud/'+imgSrc)
            },
            toFinString: function (x, fixed = 2) {
                if (x < 1000000) {
                    return x.toFixed(fixed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if (x < 1000000000) {
                    return (x / 1000000).toFixed(fixed).toString() + 'M'
                } else {
                    return (x / 1000000000).toFixed(fixed).toString() + 'B'
                }
            },
        },
        computed: {
            xsnPrice: function() {
                if (this.xsnPriceLog == 100) return 1000
                if (this.xsnPriceLog > 98) return 500
                return Math.round(Math.exp(Math.log(1) + ((Math.log(500) - Math.log(1)) / 100) * this.xsnPriceLog))
            },
            xsnPriceString: function() {
                return this.toFinString(this.xsnPrice)
            },
            currentXsnPriceString: function() {
                return this.toFinString(this.currentXsnPrice, 3)
            },
            currentMNPriceString: function() {
                return this.toFinString(this.currentXsnPrice * 15000, 2)
            },
            ownedNodes: function() {
                return Math.round(this.ownedNodesLog < 50 ? this.ownedNodesLog / 2 : (((this.ownedNodesLog - 50) * 1.5) + 25))
            },
            tradingVolume: function() {
                const val = Math.round(this.xsnPriceLog < 50 ? (this.xsnPriceLog * 20) / 2 : (((this.xsnPriceLog - 50) * 100 * 3.9) + 500))
                return val > 1000 ? Math.round(val / 500) * 500 : val
            },
            tradingVolumeString: function() {
                return this.tradingVolume < 1000 ? (this.tradingVolume + 'M') : ((this.tradingVolume / 1000).toFixed(2) + "B")
            },
            dayMonthYearMultiplier: function() {
                return (this.dayMonthYear === 'day' ? 1 : this.dayMonthYear === 'month' ? 30 : 365)
            },
            blockRewards: function () {
                return (this.ownedNodes / this.masternodeCount) * (1440 * 9) * this.xsnPrice * this.dayMonthYearMultiplier
            },
            blockRewardsString: function () {
                return this.toFinString(this.blockRewards)
            },
            orderbookRewards: function() {
                return Math.max(0.225, (0.45 - (0.000225 * this.tradingVolume))) * (this.tradingVolume * 0.0025 * 1000000) * (this.ownedNodes / this.orderbookMNs) * this.dayMonthYearMultiplier
            },
            orderbookRewardsString: function() {
                return this.toFinString(this.orderbookRewards);
            },
            mnHostingCost: function() {
                return this.ownedNodes * (this.orderbookHostingEnabled ? 2.5 : 0.15) * this.dayMonthYearMultiplier
            },
            mnHostingCostString: function() {
                return this.toFinString(this.mnHostingCost);
            },
            mnCollateralValue: function () {
                return this.xsnPrice * this.ownedNodes * 15000
            },
            mnCollateralValueString: function () {
                return this.toFinString(this.mnCollateralValue)
            },
            totalRewards: function() {
                return this.blockRewards + (this.orderbookHostingEnabled ? this.orderbookRewards : 0) - this.mnHostingCost
            },
            totalRewardsString: function() {
                return this.toFinString(this.totalRewards)
            },
            roi: function() {
                return ((((this.mnCollateralValue + this.totalRewards) / this.mnCollateralValue) - 1) * 100).toFixed(2)
            },
            daysUntilFreeMasternode: function() {
                return ((15000 * this.xsnPrice) / (this.totalRewards / this.dayMonthYearMultiplier)).toFixed(1) + ' days'
            },
            wagieEquivalence: function() {
                return ((this.totalRewards / this.dayMonthYearMultiplier) * 365 / 10000).toFixed(1);
            },
            wagieEquivalenceCeil: function() {
                return Math.ceil((this.totalRewards / this.dayMonthYearMultiplier) * 365 / 23700)
            }
        }
    }
</script>

<style lang='scss'>
    .full-screen {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .labz-text {
        top: -50px;
        background-color: black;
        width: 600px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        font-size: 30px;
    }
    .floating {
        position: relative;
        width: 600px;
        transform: translate(-50%, 0); 
        top: 200px;
        left: 50%; 
        z-index: 200;
        background-color: rgba(0, 0, 0, 0.7);
        padding: 15px;
    }
    .title-section {
        opacity: 1;
    }
</style>

